import { Controller } from "remult";

@Controller("requested-opportunity-methods")
export class RepeatedOpportunityMethods {}
